import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import ReactSVG from 'react-svg'
import { formatPhone } from 'SRC/modules/layout/Sidebar/BusinessUsersSmsAds/functions/functions'

export const CallButton = ({ phone }) => {
  const { t } = useTranslation('common')

  return (
    <a className='vehicle-part-call-button' href={`tel: +${phone}`}>
      <span>
        <ReactSVG src='/icons/telefon.svg' className='vehicle-part-call-button-icon' beforeInjection={svg => {
          svg.setAttribute('style', 'margin-right: 10px; width: 30px; height: 30px;');
          svg.querySelectorAll('.fil0').forEach(path => {
            console.log('pth', path)
            path.setAttribute('style', 'fill: #fff;');
          });
        }} wrapper='span'/>
      </span>
      <p className='vehicle-part-call-button-pozovi'>{t('Pozovi')}</p>
      <p className='vehicle-part-call-button-phone-number'>{formatPhone(phone)}</p>
    </a>
  )
}

CallButton.propTypes = {
  phone: PropTypes.string.isRequired
}
